import {configureStore, createReducer} from '@reduxjs/toolkit';
import {debounce} from '@mui/material';
import {getQepSystem} from '@qep/shared/src';
import {setDefaultAlgoDuration} from './actions.js';

export type QepPreferencesState = {
  defaultAlgoDuration?: number;
};

const defaultQepPreferencesState: QepPreferencesState = {
  defaultAlgoDuration: 15,
};

const initialState: QepPreferencesState = defaultQepPreferencesState;

let debounceSuccessNotif: (...args: any[]) => any;

export const qepPreferencesReducer = createReducer(initialState, builder => {
  builder
    .addCase(setDefaultAlgoDuration, (state, action) => {
      state.defaultAlgoDuration = action.payload.duration;
      if (action.payload.initialLoad) {
        return;
      }

      void getQepSystem().container.config.setPreference({
        field: 'qep.defaultAlgoDuration',
        value: action.payload.duration,
      }, (error, _response) => {
        if (error) {
          getQepSystem().notification.local.error(error);
          return;
        }

        debounceSuccessNotif ||= debounce(getQepSystem().notification.local.success, 700);

        debounceSuccessNotif('Default algo duration updated successfully');
      });
    });
});

export const store = configureStore({
  reducer: {
    qepPreferencesReducer,
  },
});
